

































import { Component, Vue } from 'vue-property-decorator'
import REPORT_COLUMNS from '@/config/reportForm/column-config/account-details'
import { setSessionStorage } from '../../../store/src/utils/index'
@Component
export default class Login extends Vue {
	private reportFormId: string = 'XSMX_100003'
	private settingCols: any = REPORT_COLUMNS
	private gridData: any = []
	private hidecCols: string = ''
	private sumCol: any = {}
	private dateValue: any = []
	private billState: string = ''
	private filterFormData: any = {
		restaurantName: '',
		payName: ''
	}
	private onChangeColData (hideCol: string) {
		this.hidecCols = hideCol
	}
	private async onSearch () {
		const searchFilter = await this.searchFilter('1')
		await this.searchHandler(searchFilter)
	}
	private searchFilter (ediExportParams?: string) {
		return new Promise((resolve: any) => {
			const settingMenuParams = this.settingCols.map((item) => {
				return item.prop
			})
			const params = {
				filters: {rules: this.getFiltersParams().filtersParams},
				rows: 30,
				page: 1,
				validcols: settingMenuParams.join(','),
				ediExportHideCols: ediExportParams
			}
			resolve(params)
		})
	}
	private searchHandler (params) {
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getXSMX100003Data',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private onExport () {
		this.exportFun()
	}
	private async exportFun () {
		const hideCols = this.hidecCols
		const searchFilter = await this.searchFilter(hideCols)
		const searchHandler = await this.searchHandler(searchFilter)
		await this.exportHandler(searchHandler)
	}
	private exportHandler (params) {
		window.open('/cldEdi/reportDateController/exportEdiDataCommon.do?exportType=3')
	}
	private onSortChange ({ prop, order }) {
		const settingMenuParams = this.settingCols.map((item) => {
			return item.prop
		})
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			rows: 30,
			page: 1,
			validcols: settingMenuParams.join(','),
			sord: prop === null ? null : order === 'ascending' ? 'asc' : 'desc',
			sidx: prop
		}
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getXSMX100003Data',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private setGridData (gridObj) {
		this.gridData = gridObj.currentData || []
		this.sumCol = gridObj.userdata || {}
	}
	private created () {
		setSessionStorage('titleLabel', '对账单明细表')
		this.initFilters()
	}
	private initFilters () {
		this.dateValue = [(this as any).$fxCommon.orderFilterStartDate(), (this as any).$fxCommon.orderFilterEndDate()]
	}
	private getFiltersParams () {
		const filtersParams = [] as any
		if (this.filterFormData.restaurantName) {
			const restaurantName = { field: 'restaurant_name', data: this.filterFormData.restaurantName, op: 'cn' }
			filtersParams.push(restaurantName)
		}
		if (this.filterFormData.payName) {
			const payName = { field: 'pay_name', data: this.filterFormData.payName, op: 'cn' }
			filtersParams.push(payName)
		}
		if (this.dateValue === '' ||
			this.dateValue === null ||
			this.dateValue === undefined) {
			filtersParams.push(
				{ field: 'bus_date', data: `${(this as any).$fxCommon.orderFilterStartDate()} 00:00`, op: 'ge' },
				{ field: 'bus_date', data: `${(this as any).$fxCommon.orderFilterEndDate()} 23:59`, op: 'le' }
			)
		} else {
			filtersParams.push(
				{ field: 'bus_date', data: `${this.dateValue[0]} 00:00`, op: 'ge' },
				{ field: 'bus_date', data: `${this.dateValue[1]} 23:59`, op: 'le' }
			)
		}
		return {
			filtersParams
		}
	}
}
